import { Page, Topbar } from 'components'
import { observer } from 'mobx-react'
import { Course } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { RoutingParams } from 'routes'
import { CourseStep } from 'views/course/courseStep'
import {CourseSidebar, MainSidebar } from '../views'
import { CourseStartPage } from './courseStart'


export interface ICourseProps { };

/**
 * Lets the current user complete a course.
 *
 * @type Participant, Manager
 */
export const CoursePage = observer((props: ICourseProps) => {
  const { t } = useTranslation();
  const params: RoutingParams = useParams<RoutingParams>();

  const [course,      setCourse]      = React.useState<Course>(null);
  const [onStartPage, setOnStartPage] = React.useState<boolean>(true);

  React.useEffect(() => {
    Course.get(Number(params.id)).then(async (c: Course) => {
      setCourse(c);
      await c.loadSteps();
    })
  }, [params]);

  React.useEffect(() => {
    if (!course?.getCurStep) return;

    course?.getCurStep.loadVideo();
    course?.getCurStep.loadDocuments();
  }, [course?.getCurStep]);

  let courseStage = t('start_course')
  if (course?.getProgress === 100) courseStage = t('repeat_course')
  else if (course?.getProgress > 0) courseStage = t('continue_course')

  let view: React.ReactNode = null
  if (onStartPage)
    view = (
      <CourseStartPage
        description={course?.desc}
        courseStarted={courseStage}
        course={course}
        onStart={() => setOnStartPage(false)}
      />
    )
  else if (course.getCurStep)
    view = <CourseStep course={course} step={course.getCurStep} />

  return (
    <Page
      sidebar={
        onStartPage ? <MainSidebar /> : <CourseSidebar course = {course} />
      }
      topbar = {
        <Topbar 
          title          = {course?.title}
          showBackButton = {course?.getCurStep?.isSub}
          onBack         = {() => course.setCurStep(course?.getCurStep?.getParent)}
        />
      }
    >
      {view}
    </Page>
  )
});
